<mat-sidenav-container [ngClass]="{ isMobile: isMobile$ | async }">
  <mat-sidenav mode="side" opened="true" disableClose="true" class="sidenav">
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <div
      class="main-content-wrapper"
      [@routeAnimation]="
        o.isActivated && animationEnabled ? o.activatedRoute : ''
      "
    >
      <router-outlet #o="outlet"></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
